import ChoicePicker from '../components/ChoicePicker';
import CheckboxConsentInput from '../components/CheckboxConsentInput';
import ContinueButtonBar from '../components/ContinueButtonBar';
import type { usePreEmploymentEducationFlow } from './usePreEmploymentEducationFlow';

type Flow = ReturnType<typeof usePreEmploymentEducationFlow>;

const YES_NO = (t: Flow['t']) => [
  { value: 'yes' as const, label: t('submitDocuments.preEmploymentEducation.yes') },
  { value: 'no' as const, label: t('submitDocuments.preEmploymentEducation.no') },
];

export default function PreEmploymentEducationChatComposer({ flow }: { flow: Flow }) {
  const { currentStep, t, advanceMaterials, advanceAgree, agreeChecked, setAgreeChecked, values } = flow;
  if (!currentStep) return null;

  if (currentStep.stepId === 'materialsUnderstood') {
    const current = values.educationUnderstood === 'yes' || values.educationUnderstood === 'no' ? values.educationUnderstood : null;
    return (
      <div style={{ padding: '12px 16px' }}>
        <ChoicePicker
          value={current}
          options={YES_NO(t)}
          onChange={(v) => void advanceMaterials(v)}
        />
      </div>
    );
  }

  if (currentStep.stepId === 'agree') {
    return (
      <CheckboxConsentInput
        checked={agreeChecked}
        label={t('submitDocuments.preEmploymentEducation.agreeCheckbox')}
        onChange={setAgreeChecked}
        continueLabel={t('submitDocuments.chat.continue')}
        onContinue={() => void advanceAgree()}
      />
    );
  }

  return null;
}

export function PreEmploymentEducationDeclinedComposer({
  onContinue,
}: {
  onContinue: () => void;
}) {
  return <ContinueButtonBar onContinue={onContinue} />;
}
